// Sample addresses used to stub the Google Places autocomplete in local development
// (see PlacesAutocompleteInput). Picking one builds the exact same payload the real
// Places flow produces, so the rest of the onboarding flow is unchanged.

export type DevAddressRegion = 'Florida' | 'Massachusetts' | 'Texas';

export interface DevAddress {
  region: DevAddressRegion;
  label: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface AddressParts {
  line1: string;
  postalCode: string;
  city: string;
  state: string;
  country: string;
}

export const DEV_ADDRESSES: DevAddress[] = [
  // Florida
  { region: 'Florida', label: 'Florida State Capitol', street: '400 S Monroe St', city: 'Tallahassee', state: 'FL', postalCode: '32399' },
  { region: 'Florida', label: 'Miami City Hall', street: '3500 Pan American Dr', city: 'Miami', state: 'FL', postalCode: '33133' },
  { region: 'Florida', label: 'Orlando City Hall', street: '400 S Orange Ave', city: 'Orlando', state: 'FL', postalCode: '32801' },
  // Massachusetts
  { region: 'Massachusetts', label: 'Massachusetts State House', street: '24 Beacon St', city: 'Boston', state: 'MA', postalCode: '02133' },
  { region: 'Massachusetts', label: 'Boston City Hall', street: '1 City Hall Square', city: 'Boston', state: 'MA', postalCode: '02201' },
  { region: 'Massachusetts', label: 'Fenway Park', street: '4 Jersey St', city: 'Boston', state: 'MA', postalCode: '02215' },
  // Texas
  { region: 'Texas', label: 'Texas State Capitol', street: '1100 Congress Ave', city: 'Austin', state: 'TX', postalCode: '78701' },
  { region: 'Texas', label: 'Houston City Hall', street: '901 Bagby St', city: 'Houston', state: 'TX', postalCode: '77002' },
  { region: 'Texas', label: 'Dallas City Hall', street: '1500 Marilla St', city: 'Dallas', state: 'TX', postalCode: '75201' },
];

// Mirrors the real flow's extractAddressParts: line1 is the Google `formattedAddress`
// style string, state is the 2-letter code, country is the "US" short code.
export const toAddressParts = (address: DevAddress): AddressParts => ({
  line1: `${address.street}, ${address.city}, ${address.state} ${address.postalCode}, USA`,
  postalCode: address.postalCode,
  city: address.city,
  state: address.state,
  country: 'US',
});
